/**
 * Import Lib & assets
 */

import React from "react";
import PropTypes from "prop-types";

/**
 * import components
 */

/**
 * styled components
 */

/**
 * print component is..
 */

const Svg__print = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="30">
    <path
      fillRule="evenodd"
      fill="#50BBE9"
      d="M27.313 30H1.302A1.132 1.132 0 01.17 28.869V1.444C.17.819.678.313 1.302.313h19.332v6.442c0 .755.612 1.368 1.369 1.368h6.441v20.746A1.13 1.13 0 0127.313 30zM10.436 15.831c0-1.334-.942-2.258-2.501-2.258H5.266v6.531h1.437v-1.959h1.092c1.465 0 2.641-.784 2.641-2.295v-.019zm7.08.989c0-1.838-1.419-3.247-3.47-3.247h-2.548v6.531h2.548c2.051 0 3.47-1.427 3.47-3.265v-.019zm6.253-3.247h-4.974v6.531h1.437v-2.528h3.116v-1.307h-3.116v-1.39h3.537v-1.306zm-9.723 5.234h-1.11V14.87h1.11c1.176 0 1.969.812 1.969 1.969v.018c0 1.157-.793 1.95-1.969 1.95zm-6.204-1.94H6.703V14.87h1.11c.718 0 1.165.345 1.165.989v.019c0 .56-.419.989-1.136.989zm14.229-11.2V.313l6.373 6.373H23.09a1.019 1.019 0 01-1.019-1.019z"
    />
  </svg>
);

export default Svg__print;

Svg__print.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Svg__print.defaultProps = {
  style: {},
};

/*
    import Svg__print from 'components/svg/print/svg__print'
    <Svg__print />
  */
